/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by randysorensen on 2/26/17.
 */

'use strict';

function QueuesGroupSummaryViewController($scope, $routeParams, $interval, $location, QueuesViewService, ModalService, NavbarUtilService) {
	var self = this;

	var queueGroupLabels = {
		'Deliveries': 'Delivery',
		'Transcodes': 'Transcode',
		'Restores': 'Restore'
	};

	var STATUSES = {
		executing: {
			name: 'executing',
			altName: 'active',
			label: 'Executing',
			altLabel: 'Active'
		},
		queued: {
			name: 'queued',
			label: 'Queued'
		},
		paused: {
			name: 'paused',
			label: 'Paused'
		},
		stalled: {
			name: 'stalled',
			label: 'Stalled'
		},
		finished: {
			name: 'finished',
			label: 'Finished'
		}
	};

	self.groupName = $routeParams.group;
	self.tabName = ($routeParams.group === 'fileCopy') ? 'File Copy' : $routeParams.group;

	self.groupLabel = '';

	self.groupProps = {
		chartData: {
			series: [],
			data: []
		},
		width: 500,
		height: 250
	};

	self.loadingIndicator = {
		backdrop: true,
		show: false,
		title: 'Working',
		message: 'Please wait...'
	};

	self.pollingInterval = null;
	self.showFinished = QueuesViewService.showFinishedDataInGraph;

	var pollingFrequency = 30000;

	var updateGroupLabel = function (groupName) {
		if (queueGroupLabels[groupName]) {
			return queueGroupLabels[groupName];
		}

		return groupName;
	};

	var loadQueueGroupSummary = function () {
		self.loadingIndicator.show = true;
		if (self.pollingInterval) {
			$interval.cancel(self.pollingInterval);
			self.pollingInterval = null;
		}

		QueuesViewService.loadGroupSummaryData(self.groupName).then(function (summaryData) {
			self.groupProps.chartData = summaryData;

			self.groupLabel = updateGroupLabel(summaryData.header);
			self.pollingInterval = $interval(loadQueueGroupSummary, pollingFrequency);
			self.loadingIndicator.show = false;
		});
	};

	NavbarUtilService.viewSearchFunction = loadQueueGroupSummary;

	self.getSelectedStatusForDetailGrid = function (status) {
		if (status === STATUSES.executing.label || status === STATUSES.queued.label) {
			return STATUSES.executing.altName;
		} else if (status === STATUSES.paused.label) {
			return STATUSES.paused.name;
		} else if (status === STATUSES.stalled.label) {
			return STATUSES.stalled.name;
		} else {
			return STATUSES.finished.name;
		}
	};

	self.reloadQueuesFromShowFinishedChange = function () {
		QueuesViewService.showFinishedDataInGraph = self.showFinished;
		loadQueueGroupSummary();
	};

	self.openQueueLimitersListModal = function (queueId) {
		if (self.pollingInterval) {
			$interval.cancel(self.pollingInterval);
			self.pollingInterval = null;
		}
		ModalService.showQueueLimiterModal(queueId, self.saveQueueLimiterListModal, self.closeQueueLimiterHandler);
	};

	self.saveQueueLimiterListModal = function (queueObj) {
		QueuesViewService.saveQueueLimiters(queueObj);
		self.pollingInterval = $interval(loadQueueGroupSummary, pollingFrequency);
	};

	self.closeQueueLimiterHandler = function () {
		self.pollingInterval = $interval(loadQueueGroupSummary, pollingFrequency);
	};

	self.openQueueDetailView = function (queue, status) {
		$location.url('/dashboard/queues/summary/' + self.groupName + '/' + queue.id + '/steps' + '?' + 'status=' + status);
	};

	$scope.$on('$destroy', function () {
		$interval.cancel(self.pollingInterval);
	});

	QueuesViewService.breadcrumb = {
		name: self.tabName,
		location: '/dashboard/queues/summary/' + self.groupName
	};

	loadQueueGroupSummary();
}

angular.module('prism-ui.queues').controller('QueuesGroupSummaryViewController', QueuesGroupSummaryViewController);
